import axios from '../axios'
export default function(id, options) {
  options = options || {}
  const { refresh, isAll } = options
  return new Promise(resolve => {
    if (!refresh && window.SITE_CONFIG['menuObj'][id] && window.SITE_CONFIG['menuObj'][id].children) {
      resolve(window.SITE_CONFIG['menuObj'][id])
    } else {
      axios({ timeout: isAll ? 5 * 60 * 1000 : 30 * 1000,
        url: '/zfszsk/bizlawcategoryt/listByParentId',
        method: 'get', params: { isAll: isAll || 0, parentId: id }}).then(({ data }) => {
        if (data.code === 0) {
          window.SITE_CONFIG['menuObj'][id] || (window.SITE_CONFIG['menuObj'][id] = {})
          window.SITE_CONFIG['menuObj'][id].children = data.data
          resolve(window.SITE_CONFIG['menuObj'][id])
          data.data.map((x) => {
            window.SITE_CONFIG['menuObj'][x.id] = x
            return x
          })
        }
      })
    }
  })
}
